import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Workbook as wb} from "exceljs";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {forkJoin} from "rxjs";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {ReplicaMarcionesService} from "../../services/replica-marcaciones.service";

@Component({
  selector: 'app-replica-marcacion-empleado',
  templateUrl: './replica-marcacion-empleado.component.html',
  styleUrls: ['./replica-marcacion-empleado.component.css']
})
export class ReplicaMarcacionEmpleadoComponent implements OnInit {

  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  formularioMarcacion: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;
  cmbEmployees: any[] = [];

  workbook: wb;
  data: any = [];
  dataExcel: any = [];
  uploadForm: FormGroup;
  actualWeek: number;
  recursosHumanos = false;
  @ViewChild('fileInput') fileInput: ElementRef;

  break = false;

  constructor(
    private fb: FormBuilder,
    private _replicaModificacionMarcaciones: ReplicaMarcionesService,
    private _util: UtilsService,
  ) {
    this.diccionarioModulo = moduloHorasExtras;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.horasExtrasReplicaMarcacionesEmpleado;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.calculateCombos();
    this.formulario = this.fb.group({
      id: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
    });
    this.girdComponent();
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }


  calculateCombos() {
    this.loading = true;
    const _getAllEmployees = this._replicaModificacionMarcaciones.getAllEmployees();
    forkJoin([_getAllEmployees]).subscribe((res: any) => {
      res[0].map(employe => {
        employe.id = employe.cedula;
        employe.descripcion = employe.cedula + ' | ' + employe.nombres;
      });
      this.cmbEmployees = res[0];
      this.loading = false;
    }, () => {
      this.loading = false;
      this.cmbEmployees = [];
    });
  }


  getAllTMarcaciones() {
    this.loading = true;
    const payload = this.formulario.value;
    this._replicaModificacionMarcaciones.getAllByEmployees(payload).subscribe((res: any) => {
      this.rowData = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }


  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'CEDULA',
        field: 'cedula',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'FECHA',
        field: 'fecha',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'GARITA',
        field: 'garita',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'HORA',
        field: 'hora',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'FECHA COMPLETA',
        field: 'realDate',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'ESTATUS',
        field: 'status',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'TIPO',
        field: 'tipo',
        sortable: true,
        filter: true,
        width: 150
      },
    ];
    this.rowSelection = 'single';
  }

  listAll() {
    if (this.formulario.valid) {
      this.getAllTMarcaciones();
    }
  }

}
